<div class="default-toggle-container" fxLayout="column">
  <mat-checkbox [disabled]="origDefault" [checked]="isDefault" (change)="checkedDefault($event)">
    <h4>Set as default payout method</h4>
  </mat-checkbox>

  <span *ngIf="!origDefault">
    You can set one payout method as a default. This payout method will be used for any properties that have not been
    associated with any other payout method, including properties added in the future.
  </span>

  <span *ngIf="origDefault">
    This payout method is currently set as your default payout method. To change it, edit another payout method and set
    it as the default.
  </span>
</div>
